export default __webpack_public_path__ + "5a3ea40d9ae3ef7f1dc752ad49a9b4b5.png";